import { AXELE_PERMISSION_TYPE } from '../../../common/Permission';

export const payStatementAddPermissions: {
  [key: string]: AXELE_PERMISSION_TYPE[];
} = {
  NFD: [AXELE_PERMISSION_TYPE.LOAD_FINANCIAL_PAYMENT_ADD],
  DR: [AXELE_PERMISSION_TYPE.LOAD_FINANCIAL_PAYMENT_ADD],
  SP: [AXELE_PERMISSION_TYPE.LOAD_FINANCIAL_PAYMENT_ADD],
};
